module.exports = __webpack_public_path__ + "img/logo-img.9a981c8e.svg";